import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  VirtualSportType,
} from "@/api/virtualSport";
import { useVirtualRounds } from "./useVirtualRounds";

// Per-league match-clock timing (matchStart/matchEnd/nextBetstop) for the league
// tab badge / strip / video-label countdown. DERIVED from the shared rounds query
// (timing is folded into each league's round metadata) — so it fires NO separate
// request, no matter how many leagues render a countdown. `refetch` re-polls the
// rounds feed (used by the strip to roll the instant a betstop hits 0).
export const useVirtualTiming = (
  leagueId: number,
  sportType: VirtualSportType = DEFAULT_VIRTUAL_SPORT_TYPE
) => {
  const { data: rounds = [], refetch } = useVirtualRounds(sportType);
  const timing = rounds.find((r) => r.leagueId === leagueId)?.timing ?? null;
  return { data: timing, refetch };
};
